module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-card', {
    attrs: {
      "flat": ""
    }
  }, [_c('v-card-title', {
    staticClass: "subheading"
  }, [_c('v-btn', {
    attrs: {
      "small": "",
      "icon": "",
      "loading": _vm.treatmentLogsRequest.loading
    },
    on: {
      "click": _vm.get
    }
  }, [_c('v-icon', {
    attrs: {
      "small": ""
    }
  }, [_vm._v("replay")])], 1), _vm._v("\n    " + _vm._s(_vm.$t('logs.title')) + "\n    "), _c('v-spacer'), _vm._v(" "), _c('v-btn', {
    staticClass: "ma-0",
    attrs: {
      "outline": "",
      "outlined": "",
      "small": "",
      "flat": "",
      "color": "primary"
    },
    on: {
      "click": function($event) {
        _vm.touchers.editform++;
        _vm.selectedLog = {};
        _vm.dialogs.add = true;
      }
    }
  }, [_c('v-icon', [_vm._v("add")]), _vm._v(" " + _vm._s(_vm.$t('buttons.add')) + "\n    ")], 1)], 1), _vm._v(" "), (_vm.treatmentLogs && _vm.treatmentLogs.length > 0) ? _c('v-list', {
    attrs: {
      "dense": "",
      "three-line": ""
    }
  }, [(_vm.changeLogsRequest.loading) ? _c('v-progress-linear', {
    staticClass: "pa-0 ma-0",
    attrs: {
      "indeterminate": "",
      "height": 3
    }
  }) : _vm._e(), _vm._v(" "), (_vm.treatmentLogsRequest.loading) ? _c('v-progress-linear', {
    staticClass: "pa-0 pa-0",
    attrs: {
      "indeterminate": "",
      "height": 3
    }
  }) : _vm._e(), _vm._v(" "), _vm._l((_vm.treatmentLogs), function(log, index) {
    return [(_vm.isNewPractitioner(log, index, _vm.treatmentLogs)) ? [_c('v-subheader', {
      staticClass: "grey lighten-4 overline"
    }, [_vm._v("\n              " + _vm._s(_vm.getPractitionerById(log.practitioner).full_name) + "\n          ")]), _vm._v(" "), _c('v-divider')] : _vm._e(), _vm._v(" "), _c('treatment-log-list-item', {
      key: log.id,
      attrs: {
        "item": log
      },
      on: {
        "selected": function($event) {
          _vm.selectedLog = log;
          _vm.dialogs.add = true
        },
        "clicked:delete": _vm.dodelete
      }
    })]
  })], 2) : _vm._e(), _vm._v(" "), (_vm.treatmentLogs && _vm.treatmentLogs.length === 0 && !_vm.treatmentLogsRequest.loading) ? [_c('v-divider'), _vm._v(" "), _c('v-card', {
    attrs: {
      "flat": ""
    }
  }, [_c('v-card-title', [_vm._v("\n          " + _vm._s(_vm.$t('zerocurrentresults')) + "\n          "), _c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "href": "https://www.loom.com/share/f26d5537be0540f7bd8fc82c61b9b6f6",
      "target": "_blank",
      "color": "primary",
      "small": "",
      "outline": "",
      "outlined": ""
    }
  }, [_vm._v("\n              Watch a quick video tutorial\n              "), _c('v-icon', {
    staticClass: "ml-2",
    attrs: {
      "small": ""
    }
  }, [_vm._v("open_in_new")])], 1)], 1), _vm._v(" "), _c('v-card-text', [_c('h3', {
    staticClass: "subheader"
  }, [_vm._v("What is this?")]), _vm._v(" "), _c('p', [_vm._v("\n            Client history is a place for you to manually record treatment of a patient (ICD-10 and treatment codes) over time.\n            You can record diagnosis without needing to add it to your appointments and invoices.\n          ")]), _vm._v(" "), _c('strong', [_vm._v("Benefits of keeping a manual treatment record")]), _vm._v(" "), _c('ul', [_c('li', [_vm._v("Track information from other practitioners (e.g.: referring practitioner diagnosis)")]), _vm._v(" "), _c('li', [_vm._v("Track diagnosis and treatment other than what you need to bill for")]), _vm._v(" "), _c('li', [_c('v-icon', {
    attrs: {
      "color": "amber",
      "small": ""
    }
  }, [_vm._v("flash_on")]), _c('strong', [_vm._v("Automation:")]), _vm._v(" AppointmentGuru can automatically add codes to new appointments for you")], 1)]), _vm._v(" "), _c('p', {
    staticClass: "mt-3"
  }, [_c('strong', [_vm._v("AppointmentGuru")]), _vm._v(" will also automatically keep a record of the codes you have used on appointments.\n            You can access this information from the\n            "), _c('strong', [_vm._v(_vm._s(_vm.$t('tabs.usage')))]), _vm._v("\n            tab\n          ")])])], 1)] : _vm._e(), _vm._v(" "), _c('v-dialog', {
    attrs: {
      "fullscreen": _vm.$vuetify.breakpoint.xs
    },
    model: {
      value: (_vm.dialogs.add),
      callback: function($$v) {
        _vm.$set(_vm.dialogs, "add", $$v)
      },
      expression: "dialogs.add"
    }
  }, [_c('v-toolbar', {
    attrs: {
      "dense": "",
      "color": _vm.themeColor
    }
  }, [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "icon": "",
      "dark": ""
    },
    on: {
      "click": function($event) {
        _vm.dialogs.add = false
      }
    }
  }, [_c('v-icon', {
    attrs: {
      "dark": ""
    }
  }, [_vm._v("close")])], 1)], 1), _vm._v(" "), _c('request-status', {
    attrs: {
      "request": _vm.changeLogsRequest
    }
  }), _vm._v(" "), _c('client-treatment', {
    attrs: {
      "loading": _vm.changeLogsRequest.loading,
      "touch": _vm.touchers.editform
    },
    on: {
      "save": _vm.save
    },
    model: {
      value: (_vm.selectedLog),
      callback: function($$v) {
        _vm.selectedLog = $$v
      },
      expression: "selectedLog"
    }
  })], 1)], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-376770ce","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/client/codes/TreatmentLogs.vue
// module id = 1390
// module chunks = 9